module.exports = __webpack_public_path__ + "img/money_1.4f580d0a.svg";